import type { SVGProps } from 'react'
const SvgInput = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="input_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#input_svg__a)">
      <path d="M3.054 15.332q-.708 0-1.208-.5a1.65 1.65 0 0 1-.498-1.206v-2.273h1.706v2.273h11.892V4.374H3.054v2.273H1.348V4.374q0-.708.498-1.207a1.65 1.65 0 0 1 1.208-.499h11.892q.709 0 1.208.5.498.498.498 1.206v9.252q0 .708-.498 1.207a1.64 1.64 0 0 1-1.208.499zm5.584-2.778-1.193-1.226 1.489-1.475H1.348V8.147h7.586L7.445 6.672l1.193-1.226L12.193 9z" />
    </g>
  </svg>
)
export default SvgInput
